export default __webpack_public_path__ + "static/media/developer.15ee0420.jpg";